import React from "react";
import Icon, { type IconProps } from "./Icon";
/** Minus — Lucide. https://lucide.dev/icons/minus (MIT). Copied 2026-05-16.
 *  Phase 3d: neutral/no-change pairing (KPI delta flat, audit no-op row). */
export default function Minus(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M5 12h14" />
    </Icon>
  );
}
